import { render } from "./ReportsTabs.vue?vue&type=template&id=346d3be3&scoped=true"
import script from "./ReportsTabs.vue?vue&type=script&lang=js"
export * from "./ReportsTabs.vue?vue&type=script&lang=js"

import "./ReportsTabs.vue?vue&type=style&index=0&id=346d3be3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346d3be3"]])

export default __exports__